// [INATIV-BOT] no "Inatividade": regra de lembrete/encerramento quando o cliente para de responder no bot
import { ArrowForwardIos, ContentCopy, Delete, LinkOff, HourglassEmpty } from "@mui/icons-material";
import React, { memo } from "react";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Handle } from "react-flow-renderer";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const lembrete = Number((data && data.remindMinutes) || 0);
  const final = Number((data && data.finalMinutes) || 0);
  const acao = (data && data.action) || "none";
  const fila = (data && data.queueName) || "";
  const desligado = lembrete <= 0 && (final <= 0 || acao === "none");
  const textoAcao = acao === "close" ? "encerra" : acao === "queue" ? `fila ${fila || "?"}` : "";
  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        padding: "8px",
        borderRadius: "8px",
        boxShadow: "rgba(0, 0, 0, 0.05) 0px 3px 5px",
        border: "1px solid rgba(33, 94, 151, 0.25)",
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "#0872b9",
          width: "18px",
          height: "18px",
          top: "20px",
          left: "-12px",
          cursor: "pointer",
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffff",
            width: "10px",
            height: "10px",
            marginLeft: "2.9px",
            marginBottom: "1px",
            pointerEvents: "none",
          }}
        />
      </Handle>
      <div
        style={{
          display: "flex",
          position: "absolute",
          right: 5,
          top: 5,
          cursor: "pointer",
          gap: 6,
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "12px", height: "12px", color: "#F7953B" }}
        />
        <LinkOff
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("disconnect");
          }}
          sx={{ width: "12px", height: "12px", color: "#F7953B" }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "12px", height: "12px", color: "#F7953B" }}
        />
      </div>
      <div style={{ fontSize: "16px", flexDirection: "row", display: "flex", paddingRight: 50 }}>
        <HourglassEmpty
          sx={{
            width: "16px",
            height: "16px",
            marginRight: "4px",
            marginTop: "4px",
            color: "#E65100",
          }}
        />
        <div style={{ color: "#232323", fontSize: "16px" }}>Inatividade</div>
      </div>
      <div style={{ color: "#232323", fontSize: "12px", width: 220 }}>
        <div style={{ backgroundColor: "#F6EEEE", marginTop: "4px", borderRadius: "5px" }}>
          <div style={{ padding: "6px", fontSize: "10px", textAlign: "center", color: desligado ? "#888888" : "#232323" }}>
            {desligado
              ? "Controle desligado a partir daqui"
              : [
                  lembrete > 0 ? `Lembrete: ${lembrete} min` : null,
                  final > 0 && acao !== "none" ? `Final: +${final} min (${textoAcao})` : null,
                ]
                  .filter(Boolean)
                  .join(" · ")}
          </div>
        </div>
        <div style={{ fontSize: "9px", color: "#888888", marginTop: "3px", textAlign: "center" }}>
          Vale daqui pra frente no fluxo
        </div>
      </div>
      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#0872b9",
          width: "18px",
          height: "18px",
          top: "70%",
          right: "-11px",
          cursor: "pointer",
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffff",
            width: "10px",
            height: "10px",
            marginLeft: "2.9px",
            marginBottom: "1px",
            pointerEvents: "none",
          }}
        />
      </Handle>
    </div>
  );
});
